// ShareContent (ES-13522) — the compact share body used by the single share
// popover (same surface on desktop and mobile). Destinations in a tidy row +
// a copy-link field. Styling: ShareContent.module.scss on --sh-menu-* tokens.
import { useEffect, useRef, useState } from "react";
import AppSettings from "@appsettings";
import { LinkIcon, CheckIcon } from "./subheaderIcons.js";
import styles from "./ShareContent.module.scss";

const RES = AppSettings.AWSImgRepo.resources;
const MailIcon = RES + "images/mail-icon.svg";
const XIcon = RES + "images/x-icon.svg";
const FacebookIcon = RES + "images/facebook-icon.svg";
const LinkedInIcon = RES + "images/linkedin-icon.svg";

const SUBJECT = "Check this out!";
const BODY = "I thought you might find this interesting:";

const channels = (link) => {
  const url = encodeURIComponent(link);
  const subject = encodeURIComponent(SUBJECT);
  const body = encodeURIComponent(`${BODY}\n\n${link}`);
  return [
    {
      id: "email",
      label: "Email",
      icon: MailIcon,
      href: `mailto:?subject=${subject}&body=${body}`,
    },
    {
      id: "x",
      label: "X",
      icon: XIcon,
      href: `https://twitter.com/intent/tweet?url=${url}&text=${subject}`,
    },
    {
      id: "linkedin",
      label: "LinkedIn",
      icon: LinkedInIcon,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    },
    {
      id: "facebook",
      label: "Facebook",
      icon: FacebookIcon,
      href: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    },
  ];
};

const ShareContent = ({ link, onOptionClick }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);
  const resetRef = useRef(null);

  useEffect(() => () => clearTimeout(resetRef.current), []);

  const copyLink = async () => {
    try {
      await navigator.clipboard?.writeText(link);
    } catch {
      /* clipboard blocked — still surface the selection below */
    }
    onOptionClick?.("Copy Link");
    inputRef.current?.focus();
    inputRef.current?.select();
    setCopied(true);
    clearTimeout(resetRef.current);
    resetRef.current = setTimeout(() => setCopied(false), 2200);
  };

  return (
    <>
      <div className={styles.channels}>
        {channels(link).map((c) => (
          <a
            key={c.id}
            className={styles.channel}
            href={c.href}
            onClick={() => onOptionClick?.(c.label)}
            {...(c.id === "email"
              ? {}
              : { target: "_blank", rel: "noopener noreferrer" })}
          >
            <span className={styles.channelIcon}>
              <img src={c.icon} alt="" aria-hidden="true" />
            </span>
            <span className={styles.channelLabel}>{c.label}</span>
          </a>
        ))}
      </div>

      <div className={styles.copyRow}>
        <span className={styles.copyLinkIcon} aria-hidden="true">
          <LinkIcon size={16} />
        </span>
        <input
          ref={inputRef}
          className={styles.copyInput}
          type="text"
          value={link}
          readOnly
          aria-label="Page link"
        />
        <button
          type="button"
          className={`${styles.copyBtn} ${copied ? styles.copied : ""}`}
          onClick={copyLink}
        >
          {copied ? (
            <>
              <CheckIcon size={15} />
              Copied
            </>
          ) : (
            "Copy"
          )}
        </button>
      </div>
    </>
  );
};

export default ShareContent;
